module.exports = __webpack_public_path__ + "static/img/icon-userguide.9e4bad4.png";


//////////////////
// WEBPACK FOOTER
// ./static/theme/normal/img/icon-userguide.png
// module id = 1azF
// module chunks = 15